import React from 'react';

import {observer} from 'mobx-react';
import {Tooltip} from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

import {useStores} from '../../../Hooks';
import Utility from '../../../Utility';
import FallbackImage from '../../../assets/img/image.png';

const containerClass = 'relative w-[72px] h-[72px] flex-shrink-0 rounded-input border border-panels-normal overflow-hidden cursor-pointer';
const imgClass = 'w-full h-full object-cover block';
const placeholderClass = 'w-full h-full flex items-center justify-center bg-background-normal';
const tooltipClasses = {tooltip: {className: '!text-base !text-main-normal !bg-background-normal !border !border-panels-normal !shadow-lg !rounded-input'}};

const SettingsThumbnail = observer(({imageSrc, onChange, aspectRatio = 16 / 9}) => {
    const {modalStore} = useStores();
    const hasImage = !!imageSrc;

    const handleClick = () => {
        modalStore.modalData = {
            ...modalStore.modalData,
            onMediaSelected: async (files) => {
                const file = files[0];
                const dataURL = await Utility.readDataFromUrl(file.FileId);
                const fileName = `${file.FileName}.${file.FileExtension}`;
                modalStore.modalData = {
                    ...modalStore.modalData,
                    currentlyCroppedImage: dataURL,
                    aspectRatio,
                    fileFullName: fileName,
                    saveMethod: async (imageId, thumbId) => onChange(imageId, thumbId),
                };
                modalStore.isCropperModalOpen = true;
            },
            onlyImages: true,
        };
        modalStore.isMediaLibraryModalOpen = true;
    };

    return (
        <Tooltip title="Click to change cover image" placement="bottom" enterDelay={300} componentsProps={tooltipClasses}>
            <div className={containerClass} onClick={handleClick}>
                {hasImage ? (
                    <img src={imageSrc} alt="Cover" className={imgClass} onError={(e) => { e.target.src = FallbackImage; }} />
                ) : (
                    <div className={placeholderClass}>
                        <ImageOutlinedIcon className="text-main-hover" style={{fontSize: 32}} />
                    </div>
                )}
            </div>
        </Tooltip>
    );
});

export default SettingsThumbnail;
